import { render, staticRenderFns } from "./HeartBorder.vue?vue&type=template&id=744ace44&lang=pug&"
import script from "./HeartBorder.vue?vue&type=script&lang=ts&"
export * from "./HeartBorder.vue?vue&type=script&lang=ts&"
import style0 from "./HeartBorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744ace44')) {
      api.createRecord('744ace44', component.options)
    } else {
      api.reload('744ace44', component.options)
    }
    module.hot.accept("./HeartBorder.vue?vue&type=template&id=744ace44&lang=pug&", function () {
      api.rerender('744ace44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/icons/HeartBorder.vue"
export default component.exports